/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Select, SelectItem } from '@carbon/react';
import { isEmpty } from 'lodash';

function LanguageSelector({ availableCodeLanguages = [], activeCodeLanguage = '', onChangeCodeLanguage }) {
  const { t } = useTranslation();

  const singleCodeLanguage = (isEmpty(availableCodeLanguages) && activeCodeLanguage) || availableCodeLanguages.length === 1;
  const selectedCodeLanguage = activeCodeLanguage || availableCodeLanguages[0];

  const onChange = (e) => onChangeCodeLanguage(e.target.value);

  const renderCodeLanguageSelector = () => (
    <Select
      key="codeLanguageSelector"
      hideLabel
      id="codeSnippetLanguage"
      className="codeSnippetLanguage"
      value={selectedCodeLanguage}
      required
      onChange={onChange}
      data-testid="codeLanguage-selector"
    >
      {availableCodeLanguages.map((lang) => (
        <SelectItem key={lang} value={lang} text={lang} data-testid="codeLanguage-item" />
      ))}
    </Select>
  );

  return singleCodeLanguage ? (
    <h5 className="codeSnippetLanguage codeSnippetLanguage--single" aria-label={t('code_snippet_language_label')}>
      {selectedCodeLanguage}
    </h5>
  ) : (
    renderCodeLanguageSelector()
  );
}

LanguageSelector.propTypes = {
  availableCodeLanguages: PropTypes.array,
  activeCodeLanguage: PropTypes.string,
  onChangeCodeLanguage: PropTypes.func
};

export default LanguageSelector;

